import { makeStyles, Spinner } from "@fluentui/react-components";
import {
  AirplaneLandingFilled,
  AirplaneTakeOffFilled,
} from "@fluentui/react-icons";
import { default as React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  $black,
  $cloud10,
  $cloud50,
  $cloud90,
  $sky60,
} from "../../../../cssjs/colors";
import PageEnum from "../../../../enum/PageEnum";
import { EMPTY_STATE_MESSAGE } from "../../../../utils/common/Constants";
import { StatusIconSelector } from "../../../common/icon-selectors/StatusIconSelector";
import { NoDataCard } from "../../../common/no-data-card/NoDataCard";

export const HOPOtpCard: React.FunctionComponent<any> = ({
  otpError,
  otpData,
  isOtpLoading,
}): React.JSX.Element => {
  const [otpState, setOtpState] = useState<any>({
    overall: {},
    arrival: {},
    departure: {},
  });
  const classes = useStyles();
  useEffect(() => {
    if (otpData && Array.isArray(otpData)) {
      const dataMap = otpData.reduce((acc: any, item: any) => {
        if (item.type === "Overall") {
          acc.overall = { value: item.kpiValue, status: item.status };
        } else if (item.type === "Arrivals") {
          acc.arrival = { value: item.kpiValue, status: item.status };
        } else if (item.type === "Departures") {
          acc.departure = { value: item.kpiValue, status: item.status };
        }
        return acc;
      }, {});

      setOtpState({
        overall: dataMap.overall || {},
        arrival: dataMap.arrival || {},
        departure: dataMap.departure || {},
      });
    }
  }, [otpData]);

  return (
    <Link
      to={`/${PageEnum.PageUrl.Flights}?kpiType=onTimePerformance`}
      className={`${classes.otpContainer} mb-2 text-d-none`}
      style={{ cursor: "pointer", color: $black }}
    >
      <div className={`${classes.cardIcon} fs-16 amd-container-hcenter mb-1`}>
        On Time Performance
      </div>
      {otpError && <NoDataCard message={EMPTY_STATE_MESSAGE.Data} />}
      {isOtpLoading ? (
        <Spinner
          labelPosition="below"
          label="Loading..."
          className={`${classes.cardLoader}`}
          size="small"
        />
      ) : null}
      {!otpError && !isOtpLoading && otpData ? (
        <div
          className={`amd-container-hspacebtwn ${classes.otpStatusContainer}`}
          data-testid="otp-status-values"
        >
          <div
            className={`amd-container-vcolumn amd-container-vstart ms-fontSize-14 flex-1 ${classes.otpBox}  ${classes.boxBorderRight}`}
          >
            <div>Overall</div>
            <div className="fs-16">
              <StatusIconSelector
                status={
                  otpState?.overall.status ? otpState?.overall.status : ""
                }
              />
              {otpState?.overall.value != null
                ? `${Math.round(otpState?.overall?.value)}%`
                : "N/A"}
            </div>
          </div>
          <div
            className={`amd-container-vcolumn amd-container-vstart ms-fontSize-14 flex-1 ${classes.otpBox}  ${classes.boxBorderRight}`}
          >
            <div className={`d-flex fs-14 ${classes.cardIcon}`}>
              <span className="fs-18">
                <AirplaneLandingFilled />
              </span>
              <span className={`${classes.cardText}`}>Arrival</span>
            </div>
            <div className="fs-16">
              <StatusIconSelector
                status={
                  otpState?.arrival.status ? otpState?.arrival.status : ""
                }
              />
              <span>
                {otpState?.arrival.value != null
                  ? `${Math.round(otpState?.arrival?.value)}%`
                  : "N/A"}
              </span>
            </div>
          </div>
          <div
            className={`amd-container-vcolumn amd-container-vstart ms-fontSize-14 flex-1 ${classes.otpBox}`}
          >
            <div className={`d-flex fs-14 ${classes.cardIcon}`}>
              <span className="fs-18">
                <AirplaneTakeOffFilled />
              </span>
              <span className={`${classes.cardText}`}>Departure</span>
            </div>
            <div className="fs-16">
              <StatusIconSelector
                status={
                  otpState?.departure.status ? otpState?.departure.status : ""
                }
              />
              <span>
                {otpState?.departure.value != null
                  ? `${Math.round(otpState?.departure?.value)}%`
                  : "N/A"}
              </span>
            </div>
          </div>
        </div>
      ) : null}
    </Link>
  );
};

const useStyles = makeStyles({
  otpContainer: {
    background: $cloud10,
    borderRadius: "8px",
    padding: "8px",
  },
  opfContainer: {
    background: $cloud10,
    borderRadius: "8px",
    padding: "8px 0px",
  },
  cardLoader: {
    height: "60px",
  },
  otpBox: {
    paddingLeft: "8px",
    marginRight: "4px",
  },
  boxBorderRight: {
    borderRight: `1px solid ${$cloud50}`,
  },

  otpStatusContainer: {
    paddingBottom: "4px",
  },
  cardIcon: {
    color: $sky60,
  },

  cardText: {
    color: $cloud90,
    paddingLeft: "4px",
  },
});
